<app-form-field
  [label]="label"
  [required]="required"
  [control]="control"
  [submitted]="submitted"
  [errorMessages]="errorMessages"
  [serverError]="serverError"
  actionVerb="Select"
>
  <div class="form-check form-check-inline" *ngFor="let option of options">
    <label class="form-check-label">
      <input
        class="form-check-input"
        type="radio"
        [formControl]="formControl"
        [value]="option.value"
        [name]="name"
        (click)="optionClick.emit(option.value)"
      />
      {{ option.label }}
    </label>
  </div>
</app-form-field>
